import React, { useState } from 'react';

const STORAGE_KEY = 'accelerateBannerDismissed';

const readDismissed = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (error) {
    // Private mode or blocked storage: just show the banner.
    return false;
  }
};

const AccelerateBanner = () => {
  const [dismissed, setDismissed] = useState(readDismissed);

  const handleDismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      // Ignore: dismissing still works for this page view.
    }
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div className='relative flex items-center justify-center bg-gradient-to-r from-[#312E6B] to-[#1A7CF3] px-12 py-3 font-manrope text-sm text-white sm:text-base'>
      <span className='mr-3 shrink-0 rounded-full bg-white/25 px-3 py-0.5 text-xs font-semibold'>
        New
      </span>
      <p className='text-center'>
        <span className='font-bold'>Partners Accelerate is here.</span> Close
        sooner and move up to{' '}
        <span className='font-bold text-[#FFC700]'>+2 tiers</span>. Log in to
        see how it works.
      </p>
      <button
        type='button'
        onClick={handleDismiss}
        aria-label='Dismiss announcement'
        className='absolute right-4 text-lg leading-none text-white/80 hover:text-white'
      >
        &times;
      </button>
    </div>
  );
};

export default AccelerateBanner;
